/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface BookingControllerAddPayoutAccountAttachment$Params {
  id: number;
      body: {
'attachment'?: Blob;
'type'?: string;
}
}

export function bookingControllerAddPayoutAccountAttachment(http: HttpClient, rootUrl: string, params: BookingControllerAddPayoutAccountAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerAddPayoutAccountAttachment.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

bookingControllerAddPayoutAccountAttachment.PATH = '/booking/wallet/payout_accounts/{id}';
